import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { createNewCharacterModalDetailsSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const CreateNewCharacterModal = lazy(() => import('./CreateNewCharacterModal'));

function LazyCreateNewCharacterModal() {
	const { open } = useSelector(createNewCharacterModalDetailsSelector);

	return (
		<LazyRenderLayer isShown={open}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<CreateNewCharacterModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyCreateNewCharacterModal;
